import { EntityContactProvider } from "@/react/components/entityViews/contacts/components/context/EntityContactContext";
import { ContactEditor } from "@/react/components/entityViews/contacts/components/editors/ContactEditor";
import { EntityRecord } from "@/types/entity";
import { Contact } from "@/bryntum-lib/models/Contact";

interface ContactEditorProps {
  record: {
    contact: Contact;
    entityRecord?: EntityRecord; // Optional - only provided when assigning to an entity
  };
  onClose: () => void;
  editorInstance?: unknown;
}

const SwivuContactEditorPopup = ({ record, onClose, editorInstance }: ContactEditorProps) => {
  const { contact, entityRecord = null } = record;

  return (
    <EntityContactProvider entityRecord={entityRecord}>
      <ContactEditor contact={contact} onClose={onClose} editorInstance={editorInstance} />
    </EntityContactProvider>
  );
};

export default SwivuContactEditorPopup;